export default __webpack_public_path__ + "static/media/money_charge.1de1247b.png";